<template>
  <div class="view-container">
    <div class="header">
      <div class="tab">
        <span
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="handleTabClick(0)"
        >
          海运
        </span>
        <span
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="handleTabClick(1)"
        >
          空运
        </span>
      </div>
      <div class="optheader">
        <!-- 导出按钮 -->
        <div
          v-permission="'export'"
          class="btn flex_c_c"
          style="margin-right: 12px;"
          @click="handleExport"
        >
          <i class="el-icon-download" />
          导出
        </div>

        <!-- 搜索过滤器 -->
        <BaseFilter
          :is-active="isActive"
          :width="466"
          @sendFilter="handleSearchOk"
          @reset="handleSearchReset"
        >
          <div class="filter">
            <el-form ref="searchForm" :model="searchData" label-width="70px">
              <el-form-item label="客户">
                <el-select
                  v-model="searchData.companyId"
                  style="width: 310px"
                  filterable
                  multiple
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="搜索">
                <el-input
                  v-model="searchData.search"
                  placeholder="提单号"
                  style="width: 320px"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </BaseFilter>
      </div>
    </div>

    <div class="data">
      <el-tabs
        v-model="TaxManagementStatus"
        v-loading="loading"
        type="border-card"
        class="el-tabs"
        @tab-click="handleTabClick"
      >
        <!-- 所有7501 -->
        <el-tab-pane :label="'所有(' + form.all + ')'" name="All"> </el-tab-pane>

        <!-- 待上传7501 -->
        <el-tab-pane :label="'待上传(' + form.one + ')'" name="ToBeUploaded">
        </el-tab-pane>

        <!-- 待确认7501 -->
        <el-tab-pane :label="'待确认(' + form.two + '）'" name="ToBeConfirmed">
        </el-tab-pane>

        <!-- 已确认 -->
        <el-tab-pane :label="'已确认(' + form.four + '）'" name="Confirmed">
        </el-tab-pane>

        <!-- 已拒绝 -->
        <el-tab-pane :label="'已拒绝(' + form.three + '）'" name="Rejected">
        </el-tab-pane>

        <!-- 作废 -->
        <el-tab-pane :label="'作废(' + form.five + '）'" name="Cancel">
        </el-tab-pane>

        <div class="table">
          <BaseTable
            :key="TaxManagementStatus"
            :height="height"
            :table-data="{
              ...list,
              fileds,
            }"
            :page-number="pager.PageIndex"
            :page-size="pager.PageSize"
            @handlePageChange="handlePageChange"
            @dblclick="handleRowDoubleClick"
            @selection-change="handleSelectionChange"
          >
            <template slot="opt" slot-scope="row">
              <el-popover
                :ref="`popover${row.scope.id}`"
                placement="bottom-start"
                popper-class="pop-table-opt"
                width="114"
                trigger="click"
              >
                <div class="table-opt">
                  <!-- 根据状态决定显示哪个按钮 -->
                  <div v-if="row.scope.status === 0">
                    <el-button
                      class="opt-item"
                      @click="handleCommand('upload', row.scope)"
                    >上传税金</el-button>
                  </div>
                  <div v-else>
                    <el-button
                      class="opt-item"
                      @click="handleCommand('updateupload', row.scope)"
                    >更新税金</el-button>
                  </div>
                </div>
                <img
                  slot="reference"
                  src="@/assets/images/table/opt.png"
                />
              </el-popover>
            </template>
            <template slot="fileNumber" slot-scope="row">
              <i class="el-icon-folder-opened" style="color: black" @click="viewFile(row.scope)">{{ row.scope.fileNumber }}</i>
            </template>
          </BaseTable>
        </div>
      </el-tabs>
    </div>

    <!-- 上传7501 弹窗 -->
    <el-dialog
      class="dialog"
      :visible.sync="dialogVisible"
      top="7vh"
      :title="`上传7501 - ${titleMblNo} - (${titleQty})`"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleDialogClose"
      width="32%"
    >
      <el-form
        ref="uploadForm"
        v-loading="loading"
        :model="form"
        :rules="rules"
        label-width="80px"
        style="margin-right: 20px; margin-bottom: -20px;"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="提单号" prop="mblNo">
              <el-input v-model="form.mblNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="EntryNo" prop="entryNo">
              <el-input v-model="form.entryNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提单件数" prop="qty">
              <el-input v-model.number="form.qty" autocomplete="off" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税金" prop="amount">
              <el-input v-model.number="form.amount" autocomplete="off" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="It.NO" prop="itNumber">
              <el-input v-model="form.itNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="文件" prop="file">
          <el-upload
            ref="upload"
            drag
            class="upload-demo"
            :limit="1"
            style="display: contents; margin-right: auto"
            action="#"
            :show-file-list="true"
            :http-request="handleHttpRequest"
          >
            <i class="el-icon-plus"></i>
            <div class="el-upload__text">拖拽或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="submitFinalForm">确 定</el-button>
      </span>
    </el-dialog>
    <ClearenceFileDialog :rowData="rowData" :dialogVisible="dialogVisible1" @cancel="dialogVisible1 = false"></ClearenceFileDialog>
    <DetailDrawer
      :drawer="drawer1"
      :billType="active"
      :rowData="rowData"
      @close="drawer1 = false"
    ></DetailDrawer>
  </div>
</template>

<script>
// --- 组件引入 ---
const BaseTable = () => import('@/components/table/BaseTable.vue')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const ClearenceFileDialog = () => import('@/views/system/components/ClearenceFileDialog.vue')
const DetailDrawer = () => import('@/views/bill/components/DetailDrawer.vue')

// --- API 导入 ---
import {
  getForm7501PagedList,
  uploadForm7501,
  extractTaxContext
} from '@/api/bill'
import { derive } from '@/utils/common'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'TaxManagementView', // 添加组件名称
  components: {
    BaseTable,
    BaseFilter,
    ClearenceFileDialog,
    DetailDrawer
  },
  data() {
    return {
      isActive: false, // 搜索过滤器是否激活
      active: 0, // 当前激活的标签页 (0: 海运, 1: 空运)
      rowData: {},
      mblIds: [], // 选中的 MBL ID 数组
      multipleSelection: [], // 多选的行数据
      drawer1: false, // 提单详情的可见性
      dialogVisible1: false, // 清关文件弹窗可见性
      tableData: {
        fileds: [],
        columns: [],
        total: 0
      },
      pager: {
        PageIndex: 1,
        PageSize: 20,
        QueryParam: {
          SortField: 'eta',
          SortBy: 0
        }
      },
      searchData: { // 修复: searchdata -> searchData
        search: '', // 搜索关键词
        mblNo: '',
        containerNo: '',
        ETA: '',
        entryDate: '',
        releaseDate: '',
        uploadTaxDate: '',
        companyId: [],
        importerSCINId: '',
        userGroupId: [],
        supplierId: '',
        destinCode: '',
        entryNo: '',
        isHold: 'all',
        totalTaxesMin: '',
        totalTaxesMax: '',
        parentCompanyId: ''
      },
      titleMblNo: '', // 标题提单号
      titleQty: '', // 标题件数
      TaxManagementStatus: 'All', // 当前选中的状态标签
      tabNumer: [],
      form: {
        all: 0,
        one: 0,
        two: 0,
        three: 0,
        four: 0,
        five: 0,
        remark: '',
        entryNo: '',
        mblNo: '',
        qty: null,
        itNumber: '',
        amount: null,
        file: null,
        selectedId: null
      },
      rules: {
        amount: [
          { required: true, message: '请填写金额', trigger: 'change' },
          { type: 'number', message: '税金必须为数字', trigger: 'change' }
        ],
        mblNo: [{ required: true, message: '请填写提单号', trigger: 'change' }],
        qty: [
          { required: true, message: '请填写提单件数', trigger: 'change' },
          { type: 'number', message: '提单件数必须为数字', trigger: 'change' }
        ],
        remark: [{ required: true, message: '请填写备注', trigger: 'change' }],
        file: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      dialogVisible: false,
      loading: false,
      btnloading: false,
      height: 0
    }
  },
  computed: {
    ...mapState({
      deriveLoadingS: (state) => state.deriveLoading
    }),
    ...mapGetters(['companyDrapdown']),
    list() {
      return this.tableData // 直接返回 tableData
    },
    companyOptions() {
      return this.companyDrapdown
    },
    fileds() {
      const arr = [
        {
          filed: 'opt',
          label: '',
          width: '50px',
          isCustom: true,
          fixed: 'left'
        },
        {
          filed: 'companyName',
          label: '客户',
          width: '95'
        },
        {
          filed: 'mblNo',
          label: '主提单号',
          width: '160'
        },
        {
          filed: 'blNo',
          label: '分单号',
          width: '140'
        },
        {
          filed: 'eta',
          label: 'ETA',
          width: '95'
        },
        {
          filed: 'destinCode',
          label: '目的港',
          width: '75'
        },
        {
          filed: 'qty',
          label: '件数',
          width: '60'
        },
        {
          filed: 'totalTaxes',
          label: '总税金',
          width: '75'
        },
        {
          filed: 'isHold',
          label: '查验',
          width: '50',
          formatter: (row) => {
            return row.isHold === false || row.isHold === null ? '否' : '是'
          }
        },
        {
          filed: 'fileNumber',
          label: '文件',
          width: '80',
          isCustom: true
        },
        {
          filed: 'importerName',
          label: 'Importer',
          width: '160'
        },
        {
          filed: 'supplierClearence',
          label: '清关行',
          width: '160'
        },
        {
          filed: 'refuseReason',
          label: '拒绝原因',
          width: '120'
        },
        {
          filed: 'remark',
          label: '备注',
          width: '120'
        },
        {
          filed: 'entryDate',
          label: '进入时间',
          width: '100'
        },
        {
          filed: 'releaseDate',
          label: '放行时间',
          width: '100'
        },
        {
          filed: 'uploadedDate',
          label: '上传时间',
          width: '100'
        },
        {
          filed: 'entryNo',
          label: 'EntryNo',
          width: '120'
        }
        // {
        //   filed: 'customerServiceName',
        //   label: '跟进人',
        //   width: '100'
        // }
      ]

      const containerNo = {
        filed: 'containerNo',
        label: '柜号',
        width: '120'
      }

      const statuObj = {
        filed: 'statuName',
        label: '状态',
        width: '100'
      }

      if (this.active === 0) {
        arr.splice(3, 0, containerNo)
      }
      if (
        this.TaxManagementStatus === 'All'
      ) {
        arr.splice(7, 0, statuObj) // 插入到索引 7
      }

      return arr
    }
  },
  watch: {
    deriveLoadingS(newVal) {
      this.btnloading = newVal
    }
  },
  created() {
    this.initList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 120
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    /**
     * 初始化列表数据
     */
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20,
        QueryParam: {
          mblType: this.active,
          status: this.TaxManagementStatus === 'All' ? undefined : this.TaxManagementStatus,
          SortField: 'eta',
          SortBy: 0
        }
      }
      this.pager = param
      this.getList(param)
    },

    /**
     * 处理标签页切换
     */
    handleTabClick(indexOrEvent) {
      // 如果是点击事件对象，获取索引
      if (typeof indexOrEvent === 'object' && indexOrEvent !== null) {
        // 通常这里处理的是 tab-click 事件，indexOrEvent 本身是事件对象
        // 我们使用 TaxManagementStatus 作为当前激活的状态
      } else {
        // 这里处理的是 TabhandleClick 方法
        this.active = indexOrEvent
      }
      this.initPage()
      this.searchList()
    },

    /**
     * 处理搜索重置
     */
    handleSearchReset() {
      this.isActive = false
      this.searchData = {
        search: '',
        mblNo: '',
        containerNo: '',
        ETA: '',
        entryDate: '',
        releaseDate: '',
        uploadTaxDate: '',
        companyId: [],
        importerSCINId: '',
        userGroupId: [],
        supplierId: '',
        destinCode: '',
        entryNo: '',
        isHold: 'all',
        totalTaxesMin: '',
        totalTaxesMax: '',
        parentCompanyId: ''
      }
      this.initPage()
      this.searchList()
    },

    /**
     * 处理搜索提交
     */
    handleSearchOk() {
      this.initPage()
      this.searchList()
      this.isActive = true
    },

    /**
     * 初始化分页参数
     */
    initPage() {
      this.pager = {
        PageIndex: 1,
        PageSize: 20
      }
    },

    /**
     * 构造并发送搜索请求
     */
    searchList() {
      const params = {
        ...this.pager, // 展开 pager 对象
        QueryParam: {
          ...this.pager.QueryParam,
          status:
            this.TaxManagementStatus === 'All' ? undefined : this.TaxManagementStatus,
          mblType: this.active,
          Search: this.searchData.search || undefined,
          mblNo: this.searchData.mblNo || undefined,
          containerNo: this.searchData.containerNo || undefined,
          isHold:
            this.searchData.isHold === 'all'
              ? undefined
              : this.searchData.isHold,
          startETA: this.searchData.ETA ? this.searchData.ETA[0] : undefined,
          endETA: this.searchData.ETA ? this.searchData.ETA[1] : undefined,
          startentryDate: this.searchData.entryDate
            ? this.searchData.entryDate[0]
            : undefined,
          endentryDate: this.searchData.entryDate
            ? this.searchData.entryDate[1]
            : undefined,
          startreleaseDate: this.searchData.releaseDate
            ? this.searchData.releaseDate[0]
            : undefined,
          endreleaseDate: this.searchData.releaseDate
            ? this.searchData.releaseDate[1]
            : undefined,
          startUploadTaxDate: this.searchData.uploadTaxDate
            ? this.searchData.uploadTaxDate[0]
            : undefined,
          endUploadTaxDate: this.searchData.uploadTaxDate
            ? this.searchData.uploadTaxDate[1]
            : undefined,
          destinCode: this.searchData.destinCode || undefined,
          entryNo: this.searchData.entryNo || undefined,
          companyId: this.searchData.companyId || undefined,
          supplierId: this.searchData.supplierId || undefined,
          importerSCINId: this.searchData.importerSCINId || undefined,
          userGroupId: this.searchData.userGroupId[0] || undefined,
          customerServiceId: this.searchData.userGroupId[1] || undefined,
          totalTaxesMin: this.searchData.totalTaxesMin || undefined,
          totalTaxesMax: this.searchData.totalTaxesMax || undefined,
          parentCompanyId: this.searchData.parentCompanyId || undefined,
          SortField: 'eta',
          SortBy: 0
        }
      }
      this.getList(params)
    },

    /**
     * 处理分页变化
     */
    handlePageChange(pager) {
      this.pager.PageIndex = pager.pageIndex
      this.pager.PageSize = pager.pageSize
      this.searchList()
    },
    /**
     * 处理行双击事件
     */
    async handleRowDoubleClick(row) {
      await this.$store.dispatch('getAddressBookOptions', {
        type: -1
      })
       this.rowData = {
        ...row,
        id: row.mblId,
        status: row.mblStatus
       }
      // this.rowData.id = row.mblId
      // this.rowData.status = row.mblStatus
      this.drawer1 = true
    },

    /**
     * 处理选择变化
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.mblIds = val.map(item => item.mblId).filter(id => id) // 过滤掉 undefined/0
      // 注意：如果 id 本身就是 0，需要特殊处理，但根据业务逻辑，一般 id 不会是 0
      // 如果需要，可以改为：val.filter(item => item.id !== undefined && item.id !== null).map(item => item.id)
    },

    /**
     * 处理操作下拉菜单命令
     */
    handleCommand(key, row) {
      switch (key) {
        case 'upload':
          this.handleUploadClick(row)
          break
        case 'updateupload':
          this.handleUploadClick(row)
          break
        default:
          console.warn(`Unknown command: ${key}`)
      }
    },

    /**
     * 处理上传按钮点击
     */
    handleUploadClick(row) {
      this.titleMblNo = row.mblNo
      this.titleQty = row.qty
      this.form.selectedId = row.id // 存储选中的行的ID

      if (row.status === 0) {
        // 如果是待上传，可以不填备注
        this.$set(this.rules.remark, 0, { required: false })
      } else {
        this.$set(this.rules.remark, 0, {
          required: true,
          message: '请填写备注',
          trigger: 'change'
        })
      }
      this.dialogVisible = true // 显示弹窗
      this.resetForm() // 重置表单
    },

    /**
     * 重置上传表单
     */
    resetForm() {
      // 重置表单字段
      this.form.remark = ''
      this.form.entryNo = ''
      this.form.mblNo = ''
      this.form.qty = null
      this.form.itNumber = ''
      this.form.amount = this.form.selectedId ? this.$store.state.currentRow?.totalTaxes : 0 // 根据实际需求设置初始值
      this.form.file = null
      // 重置上传组件
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
      if (this.$refs.uploadForm) {
        this.$refs.uploadForm.resetFields()
      }
    },

    /**
     * 处理弹窗关闭
     */
    handleDialogClose() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
      this.dialogVisible = false
    },

    /**
     * 处理文件上传请求 (识别税金)
     */
    async handleHttpRequest({ file }) {
      try {
        this.loading = true
        const formData = new FormData()
        formData.append('input.file', file)

        const result = await extractTaxContext(formData)

        if (result.data.success) {
          this.$message.success('识别成功')
          const output = result.data.data // 获取接口返回的数据
          this.form.amount = output.totalTaxes
          this.form.entryNo = output.entryNo
          this.form.mblNo = output.mblNo
          this.form.qty = output.qty
          this.form.itNumber = output.itNumber
          this.form.file = file
        } else {
          this.$message.error(result.data.errorMessage || '文件解析失败')
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles()
          }
          if (this.$refs.uploadForm) {
            this.$refs.uploadForm.resetFields()
          }
        }
      } catch (error) {
        console.error('File extraction error:', error)
        this.$message.error(error.message || '文件解析失败')
        if (this.$refs.upload) {
          this.$refs.upload.clearFiles()
        }
        if (this.$refs.uploadForm) {
          this.$refs.uploadForm.resetFields()
        }
      } finally {
        this.loading = false
      }
    },

    /**
     * 提交最终表单
     */
    submitFinalForm() {
      this.$refs.uploadForm.validate(async(valid) => {
        if (!valid) {
          this.$message.error('请检查表单填写')
          return
        }

        try {
          this.loading = true
          const formData = new FormData()
          formData.append('input.file', this.form.file)
          formData.append('input.id', this.form.selectedId)
          formData.append('input.totalTaxes', this.form.amount)
          formData.append('input.remark', this.form.remark)
          formData.append('input.entryNo', this.form.entryNo)
          formData.append('input.mblNo', this.form.mblNo)
          formData.append('input.qty', this.form.qty)
          formData.append('input.itNumber', this.form.itNumber)

          const result = await uploadForm7501(formData)

          if (result.data.success) {
            this.$message.success('上传成功')
            this.handleSuccess() // 自定义处理逻辑
          } else {
            this.$message.error(result.data.errorMessage)
            if (this.$refs.upload) {
              this.$refs.upload.clearFiles()
            }
            if (this.$refs.uploadForm) {
              this.$refs.uploadForm.resetFields()
            }
          }
        } catch (error) {
          console.error('Upload error:', error)
          this.$message.error(error.message || '请求失败')
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles()
          }
          if (this.$refs.uploadForm) {
            this.$refs.uploadForm.resetFields()
          }
        } finally {
          this.loading = false
        }
      })
    },

    /**
     * 处理成功上传后的行为
     */
    handleSuccess() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
      if (this.$refs.uploadForm) {
        this.$refs.uploadForm.resetFields()
      }
      this.titleMblNo = '' // 重置标题提单号
      this.titleQty = '' // 重置标题件数
      this.dialogVisible = false
      this.initPage()
      this.searchList()
    },

    /**
     * 获取列表数据
     */
    getList(params) {
      getForm7501PagedList(params).then((res) => {
        if (res.success) {
          // 处理数据格式
          this.tableData.columns = res.data.list.map(item => ({
            ...item,
            eta: item.eta?.substring(0, 10),
            etd: item.etd?.substring(0, 10),
            entryDate: item.entryDate ? item.entryDate.substring(0, 10) : '',
            releaseDate: item.releaseDate ? item.releaseDate.substring(0, 10) : '',
            uploadedDate: item.uploadedDate ? item.uploadedDate.substring(0, 10) : ''
          }))

          this.tableData.total = res.data.total

          // 更新 tab 数字
          this.updateTabNumbers(res.data.tabNumer || [])

          // 保存 tabNumer 供后续使用
          this.tabNumer = res.data.tabNumer || []
        } else {
          this.$message.error(res.errorMessage || '获取列表失败')
        }
      }).catch(error => {
        console.error('Get list error:', error)
        this.$message.error('网络错误，请稍后再试')
      })
    },

    /**
     * 更新 tab 数字统计
     */
    updateTabNumbers(tabNumer) {
      // 初始化所有数值为 0
      this.form.all = 0
      this.form.one = 0
      this.form.two = 0
      this.form.three = 0
      this.form.four = 0
      this.form.five = 0

      // 遍历 tabNumer 并累加
      if (Array.isArray(tabNumer) && tabNumer.length > 0) {
        tabNumer.forEach(item => {
          if (item.type === 0) {
            this.form.one = item.qty
          } else if (item.type === 1) {
            this.form.two = item.qty
          } else if (item.type === 2) {
            this.form.three = item.qty
          } else if (item.type === 3) {
            this.form.four = item.qty
          } else if (item.type === 4) {
            this.form.five = item.qty
          }
          // 累加到 all
          this.form.all += item.qty
        })
      }
    },

    /**
     * 处理导出按钮点击
     */
    async handleExport() {
      const params = {
        status:
          this.TaxManagementStatus === 'All' ? undefined : this.TaxManagementStatus,
        mblType: this.active,
        Search: this.searchData.search || undefined,
        mblNo: this.searchData.mblNo || undefined,
        containerNo: this.searchData.containerNo || undefined,
        isHold:
          this.searchData.isHold === 'all' ? undefined : this.searchData.isHold,
        startETA: this.searchData.ETA ? this.searchData.ETA[0] : undefined,
        endETA: this.searchData.ETA ? this.searchData.ETA[1] : undefined,
        startentryDate: this.searchData.entryDate
          ? this.searchData.entryDate[0]
          : undefined,
        endentryDate: this.searchData.entryDate
          ? this.searchData.entryDate[1]
          : undefined,
        startreleaseDate: this.searchData.releaseDate
          ? this.searchData.releaseDate[0]
          : undefined,
        endreleaseDate: this.searchData.releaseDate
          ? this.searchData.releaseDate[1]
          : undefined,
        startUploadTaxDate: this.searchData.uploadTaxDate
          ? this.searchData.uploadTaxDate[0]
          : undefined,
        endUploadTaxDate: this.searchData.uploadTaxDate
          ? this.searchData.uploadTaxDate[1]
          : undefined,
        destinCode: this.searchData.destinCode || undefined,
        entryNo: this.searchData.entryNo || undefined,
        companyId: this.searchData.companyId || undefined,
        supplierId: this.searchData.supplierId || undefined,
        importerSCINId: this.searchData.importerSCINId || undefined,
        userGroupId: this.searchData.userGroupId[0] || undefined,
        customerServiceId: this.searchData.userGroupId[1] || undefined,
        totalTaxesMin: this.searchData.totalTaxesMin || undefined,
        totalTaxesMax: this.searchData.totalTaxesMax || undefined
      }

      this.btnloading = true
      try {
        await derive('TaxManagement/export', 'post', params, null)
      } catch (error) {
        console.error('Export error:', error)
        this.$message.error('导出失败')
      } finally {
        this.btnloading = false
      }
    },
    viewFile(row) {
        this.rowData = row
        this.dialogVisible1 = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-container {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;

  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }

    .active {
      color: rgb(18, 88, 188);
    }

    .type-tab {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      border-radius: 2px 2px 2px 2px;
      overflow: hidden;

      & > span {
        height: 30px;
        padding: 7px 12px;
        box-sizing: border-box;
        background: #f7f7f7;
        cursor: pointer;

        &.active {
          color: #ffffff;
          background: rgb(18, 88, 188);
        }
      }
    }
  }

  .optheader {
    display: flex;

    & > div + div {
      margin-left: 8px;
    }

    .search {
      position: relative;
      display: flex;
      width: 200px;

      .input-search {
        width: 170px;
        height: 30px !important;

        /deep/ .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }

      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    /deep/ .el-input__inner {
      height: 30px;
    }

    .add {
      width: 84px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(18, 88, 188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
      line-height: 24px;

      .icon {
        font-size: 20px;
      }
    }

    .filter {
      width: 84px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid rgb(18, 88, 188);
      border-color: rgba(35, 149, 243, 0.4);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
      line-height: 24px;
    }
  }

  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn {
    width: 80px;
    height: 30px;
    background: rgb(18, 88, 188);
    border-radius: 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }

  .data {
    width: 100%;
    height: calc(100% - 50px);

    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }

  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }

  .table-opt:deep(.el-button) {
    padding: 0;
  }

  .status {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 20px;
    margin-left: 5px;
    margin-right: 31px;
  }
}

:deep(.el-upload-dragger) {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 470px;
  height: 100px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

:deep(.el-upload-list) {
  float: none;
}
</style>
